export const initState = {
    userId: '',
    userNm: '',
    homeId: '',
    ownDeviceId: '',
    roleCd: '',
    roleNm: '',
};
export default {
    namespaced: true,
    state: initState,
    getters: {},
    mutations: {
        clear(state) {
            state.userId = '';
            state.userNm = '';
            state.ownDeviceId = '';
            state.roleCd = '';
            state.roleNm = '';
        },
        setRole(state, payload) {
            state.roleCd = payload.roleCd;
            state.roleNm = payload.roleNm;
        },
        setHomeId(state, payload) {
            state.homeId = payload.homeId;
        },
        setOwnDeviceId(state, payload) {
            state.ownDeviceId = payload.deviceId;
        },
        setUserId(state, payload) {
            state.userId = payload;
        },
    },
    actions: {
        clear({ commit }) {
            commit('clear');
        },
        setRole({ commit }, payload) {
            commit('setRole', payload);
        },
        setHomeId({ commit }, payload) {
            commit('setHomeId', payload);
        },
        setOwnDeviceId({ commit }, payload) {
            commit('setOwnDeviceId', payload);
        },
        setUserId({ commit }, payload) {
            commit('setUserId', payload);
        },
    },
};
